import React from 'react';
import { NavLink, Outlet, Link, useNavigate } from 'react-router-dom';
import { setAdminToken } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Package, Tag, Image as ImageIcon, LogOut } from 'lucide-react';

function SideLink({ to, label, Icon, testId }) {
    return (
        <NavLink
            to={to}
            data-testid={testId}
            className={({ isActive }) =>
                `flex items-center gap-3 rounded-xl px-3 py-2 text-sm transition-colors ${
                    isActive
                        ? 'bg-[color:var(--paper)] text-[color:var(--umber)] border border-[color:var(--border)]'
                        : 'text-[color:var(--graphite)] hover:bg-[color:var(--paper)]'
                }`
            }
        >
            <Icon className="h-4 w-4" />
            {label}
        </NavLink>
    );
}

export default function AdminLayout() {
    const navigate = useNavigate();
    function logout() {
        setAdminToken(null);
        navigate('/admin/login');
    }
    return (
        <div className="min-h-screen bg-[color:var(--paper)] grid grid-cols-1 lg:grid-cols-[260px_1fr]">
            <aside className="bg-[color:var(--paper-2)] border-r border-[color:var(--border)] p-5 lg:min-h-screen">
                <Link to="/" className="font-display text-lg text-[color:var(--umber)] block">Leiha Martin Art</Link>
                <p className="text-xs text-[color:var(--muted-fg)] mt-1">Studio admin</p>
                <nav className="mt-8 space-y-1">
                    <SideLink to="/admin/orders" label="Orders" Icon={Package} testId="admin-nav-orders" />
                    <SideLink to="/admin/pricing" label="Pricing" Icon={Tag} testId="admin-nav-pricing" />
                    <SideLink to="/admin/gallery" label="Gallery" Icon={ImageIcon} testId="admin-nav-gallery" />
                </nav>
                <div className="mt-10">
                    <Button variant="ghost" onClick={logout} data-testid="admin-logout-button" className="w-full justify-start rounded-xl text-[color:var(--graphite)] hover:bg-[color:var(--paper)]">
                        <LogOut className="h-4 w-4 mr-2" /> Sign out
                    </Button>
                </div>
            </aside>
            <main className="min-w-0">
                <div className="px-6 sm:px-8 py-8">
                    <Outlet />
                </div>
            </main>
        </div>
    );
}
